import React, { createContext, useContext, useReducer } from 'react';


const appState = {
  user: null,
  sidebar: true,
  settings: null,
  version: null,

  // forceReload: false,
  // forceReloadScenario: false,

  // refreshGroups: false,
  // refreshLocations: false,
  // refreshScenarios: false,
  // refreshDeployments: false,

  loading: false,

  storedFilteredRows: [],
  storedMaxRowLines: [],
  storedHeaderLinesRatio: [],
  storedColumns: [],
  storedWithExtraColumns: [],

  storedDeployments: [],
  storedSortModel: [],
  storedReports: [],
  storedRowIndex: 0,
  storedUniqueCount: 0,

  storedWelcomeScreenManualInputs: [],
  storedSdsQuestions: [],
  storedScriptHeaders: [],
  storedMobileOthersData: [],
  storedSdsExtraDiskHealthFlag: false,
  storedSdsExtraDiskPerfFlag: false,

  storedPanePrimaryHeight: null,
  storedEnabledWidgets: []
};

const AppContext = createContext();
export const AppProvider = ({ reducer, children }) => (
  <AppContext.Provider value={useReducer(reducer, appState)}>
    {children}
  </AppContext.Provider>
);

export const useAppContext = () => useContext(AppContext);
